module.exports = __webpack_public_path__ + "media/images/icon__search--rb-white-ec5c0744c3e5536471764ba9c344a81e.png";